module.exports = __webpack_public_path__ + "static/googlePay-d6e7a7545fd26f15ac3e3318dbd8136f.jpeg";